import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({
  isInEditMode,
  turnOnEditMode,
  turnOffEditMode,
  submitting,
  submitForm
}) => {
  return (
    <div className="Options">
      {isInEditMode && (
        <div className="editModeOnButtons">
          <Button white className="cancel" onClick={turnOffEditMode}>
            Cancel
          </Button>
          <Button
            className="save"
            disabled={submitting}
            blue={!submitting}
            isLoading={submitting}
            onClick={submitForm}>
            Save
          </Button>
        </div>
      )}
      {!isInEditMode && (
        <Button white className="edit" onClick={turnOnEditMode}>
          Edit
        </Button>
      )}
    </div>
  );
};

export default Buttons;
